// External Dependencies
import Paper from 'material-ui/Paper';
import PropTypes from 'prop-types';
import React from 'react';

// Internal Dependencies
import MainScrollContainer from '../main-scroll-container';

// Local Dependencies
import Nav from './nav';
import TitleBar from './title-bar';

// Local Variables
const propTypes = {
  alert: PropTypes.node,
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  iconButtons: PropTypes.node,
  nav: PropTypes.node,
  navPadding: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  navWidth: PropTypes.number,
  title: PropTypes.string,
};

const defaultProps = {
  alert: null,
  backgroundColor: '',
  iconButtons: null,
  nav: '',
  navPadding: '',
  navWidth: 0,
  title: '',
};

const paperStyles = {
  display: 'flex',
  flex: '1 0 auto',
  flexFlow: 'column',
  zindex: 20,
};

const rowStyles = {
  display: 'flex',
  flex: '1 0 auto',
};

const contentStyles = {
  display: 'flex',
  flex: 1,
  // Needed for ellipsis content
  minWidth: 0,
  position: 'relative',
  width: '100%',
};

// Component Definition
export const MainContentContainer = (props) => {
  const {
    backgroundColor,
    children,
    iconButtons,
    nav,
    navPadding,
    navWidth,
    title,
    ...other
  } = props;

  return (
    <MainScrollContainer key="main-scroll-container" {...other}>
      <Paper style={paperStyles}>
        <TitleBar
          backgroundColor={backgroundColor}
          title={title}
        >
          {iconButtons}
        </TitleBar>
        <div style={rowStyles}>
          <Nav padding={navPadding} width={navWidth}>
            {nav}
          </Nav>
          <div style={contentStyles}>
            {children}
          </div>
        </div>
      </Paper>
    </MainScrollContainer>
  );
};

MainContentContainer.propTypes = propTypes;
MainContentContainer.defaultProps = defaultProps;
export default MainContentContainer;



/** WEBPACK FOOTER **
 ** ./src/shared/main-content-container/index.js
 **/